var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19194 14.8829L6.19779 14.8888C6.48485 15.1758 6.95681 15.1759 7.24387 14.8888L11.5905 10.5421C11.8168 10.3159 12.1849 10.3159 12.4111 10.5421L16.7578 14.8888C17.0449 15.1759 17.5168 15.1759 17.8039 14.8888C18.0909 14.6017 18.0909 14.1298 17.8039 13.8427L13.4572 9.49605C12.6568 8.69565 11.3449 8.69565 10.5445 9.49605L6.19779 13.8427C6.05041 13.9901 5.98083 14.1789 5.98083 14.3658C5.98083 14.5597 6.06178 14.7435 6.19194 14.8829Z",
    fill: "#6553F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSelect);
export default __webpack_public_path__ + "static/media/ChevronSelect.512fec8f9c651dbf18ad82849c79042a.svg";
export { ForwardRef as ReactComponent };